import React, { useState, useEffect } from "react";
import "./Logo.css";

export default function Logo({ isDarkMode, className = "" }) {
  const [hovered, setHovered] = useState(false);
  const [fillDone, setFillDone] = useState(false);
  const [showFullName, setShowFullName] = useState(false);

  useEffect(() => {
    let fillTimer, textTimer;

    if (hovered) {
      fillTimer = setTimeout(() => setFillDone(true), 1200);
      textTimer = setTimeout(() => setShowFullName(true), 1800);
    } else {
      setFillDone(false);
      setShowFullName(false);
    }

    return () => {
      clearTimeout(fillTimer);
      clearTimeout(textTimer);
    };
  }, [hovered]);

  return (
   <div
      className={`logo-container ${className}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className={`circle-wrapper ${isDarkMode ? "dark" : "light"}`}>
        <svg className="circle-svg" viewBox="0 0 100 100">
          <circle
            className={`circle-stroke ${hovered ? "draw" : ""}`}
            cx="50"
            cy="50"
            r="45"
          />
          {fillDone && (
            <circle className="circle-fill" cx="50" cy="50" r="45" />
          )}
        </svg>

        <div
          className={`letter ${hovered ? "glow" : ""} ${
            showFullName ? "full-name hollow" : ""
          }`}
        >
          {showFullName ? "Edison" : "E"}
        </div>
      </div>
    </div>
  );
}
